var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"boxofficefnb_SalesReceipt",staticClass:"d-none"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.EjsData)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaa74472","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PosBookingContainer/ReceiptTemplates/bo&fnb_sales_receipt.vue
// module id = null
// module chunks = 